module.exports = __webpack_public_path__ + "img/11.196910d4.png";